// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"490":"eeb6d063","936":"eeb6d063","983":"eeb6d063"}[chunkId] + ".css";
};